import React from 'react';

class VisualStateBtn extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            visualState: ''
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const curState = this.state;
        const curProps = this.props;

        if (curState.visualState !== nextState.visualState ||
            curProps.visualStatePanelOpened !== nextProps.visualStatePanelOpened) {
            return true;
        }

        return false;
    }

    componentDidMount() {
        window.addEventListener('updateVisualStateBtn', this.updateValue, false);
    }

    componentWillUnmount() {
        window.removeEventListener('updateVisualStateBtn', this.updateValue, false);
    }

    updateValue = (e) => {
        if (e && e.type === 'updateVisualStateBtn') {
            if (e.detail.visualState) {
                this.setState({ visualState: JSON.stringify(e.detail.visualState, false, 4) });
            }
        }
    }

    render() {
        const {
            classes,
            visualStatePanelOpened
        } = this.props;

        const {
            visualState,
        } = this.state;

        return (
                <div className={`visual-state-btn ${classes} ${visualState && 'filled'} ${visualStatePanelOpened && 'opened'}`}>
                    <i className="icon icon-alan-visual-state" />
                </div>
        );
    }
}

export default VisualStateBtn;